/**
 * The way out of a screen that opens over a client's plan (Explore Coverage, the Funding plan),
 * sitting at the top right of its header and naming where it goes: "Back to Clients" or "Back to
 * Financing Plan". Phones show just the arrow in a round button like the header's other icon
 * buttons; the full label stays as the accessible name.
 *
 * It replaced the "Financing plan › …" breadcrumb, which was too subtle to find and always named
 * the Financing plan even when the screen was opened from the clients dashboard. Callers get the
 * label and destination from `useBackDestination`.
 */
import { ArrowLeft } from 'lucide-react';

import { Button } from '@design-system';

interface PlanBackButtonProps {
  label: string;
  onClick: () => void;
  testId?: string;
}

export function PlanBackButton({ label, onClick, testId }: PlanBackButtonProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      className="rounded-full max-sm:size-9 max-sm:!px-0"
      onClick={onClick}
      aria-label={label}
      data-testid={testId}
    >
      <ArrowLeft />
      <span className="hidden sm:inline">{label}</span>
    </Button>
  );
}
